import { Container, Row, Column, Col, Label } from "reactstrap"
import { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import BaseHeading from "../../../../baseComponents/baseHeading.js"
import BaseInput from "../../../../baseComponents/baseInput.js"
import BaseButton from "../../../../baseComponents/baseButton.js"
import { asyncActions as userAsyncActions } from "../../../../store/slices/userSlice.js"
import "react-datepicker/dist/react-datepicker.css"
import BaseDatepicker from "../../../../baseComponents/baseDatepicker.js"
import settings from "../../../../constants/frontEndSettings"
import BaseRadioButton from "../../../../baseComponents/baseRadioButton.js"
import useBootstrap from "../../../../customHooks/useBootstrap.js"
import useColors from "../../../../customHooks/useColors"
import BaseDropdown2 from "../../../../baseComponents/baseDropdown2.js"
import DataProcessingCheckbox from "../../../../components/DataProcessingCheckbox.js"
import ApplicationRulesCheckbox from "../../../../components/ApplicationRulesCheckbox.js"
import NotificationsCheckbox from "../../../../components/NotificationsCheckbox.js"
import OffersPromotionsCheckbox from "../../../../components/OffersPromotionsCheckbox.js"
import WithVerifyMailModal from "../../../../HOC/WithVerifyMailModal.js"
import WithVerifyMobileModal from "../../../../HOC/WithVerifyMobileModal.js"
import CopySVG from "../../../../assets/copy.svg"
import CheckmarkSVG from "../../../../assets/check.svg"
import BaseImage from "../../../../baseComponents/baseImage.js"
import BaseParagraph from "../../../../baseComponents/baseParagraph.js"
import { CopyToClipboard } from "react-copy-to-clipboard"

const PersonalDataComponent2 = ({
  mainTemplateOptions,
  openVerifyMailModal,
  openVerifyMobileModal,
}) => {
  ///////////////////////////////////////////////////////////////// DISPATCHER
  const dispatch = useDispatch()

  ///////////////////////////////////////////////////////////////// CONSTANTS
  const [currentColors] = useColors()

  const { trashold, trashold4, classes } = useBootstrap()

  ///////////////////////////////////////////////////////////////// REDUX STATES
  const userState = useSelector((state) => state.userState)
  const loginState = useSelector((state) => state.loginState)
  const countriesState = useSelector((state) => state.countriesState)
  const systemState = useSelector((state) => state.systemState)
  const citiesState = useSelector((state) => state.citiesState)

  ///////////////////////////////////////////////////////////////// LOCAL STATES
  const [name, setName] = useState("")
  const [lastName, setLastName] = useState("")
  const [email, setEmail] = useState("")
  const [dateOfBirth, setDateOfBirth] = useState("")
  const [gender, setGender] = useState("")

  const [acceptDataProcessing, setAcceptDataProcessing] = useState("")
  const [acceptRules, setAcceptRules] = useState("")
  const [acceptNotifications, setAcceptNotifications] = useState("")
  const [acceptOffers, setAcceptOffers] = useState("")

  const [phone, setPhone] = useState("")
  const [countryCode, setCountryCode] = useState("")
  const [postNumber, setPostNumber] = useState("")
  const [placeOfResidence, setPlaceOfResidence] = useState("")
  const [typeOfCommunication, setTypeOfCommunication] = useState("")
  const [errorMsg, setErrorMsg] = useState("")
  const [referenceCode, setReferenceCode] = useState("")
  const [isCopied, setIsCopied] = useState(false)

  ///////////////////////////////////////////////////////////////// VARIABLES DRIVEN FROM STATE
  //from user state
  const req_permission1 = systemState.settings.req_permission1
  const req_permission2 = systemState.settings.req_permission2
  const req_permission3 = systemState.settings.req_permission3
  const req_permission4 = systemState.settings.req_permission4
  const birthDateChanged = userState.birthDateChanged
  //from login state
  const isMailVerified = loginState.login.userInfo.isMailVerified
  const isPhoneVerified = loginState.login.userInfo.isPhoneVerified
  const countryCodeLocked = countriesState.lockPhoneCountryCode
  //from country state
  const defCountryPhoneCode = countriesState.defCountryPhoneCode

  const samePhoneAsDB =
    (userState.mobileCountryStart ?? "") + (userState.mobile ?? "") ===
    (countryCode ?? "") + (phone ?? "")

  //////////////////////////////////////////// HANDLING ACTIONS

  const handleNameChange = (e) => {
    clearUserError()
    setName(e.target.value)
  }

  const handleLastNameChange = (e) => {
    clearUserError()
    setLastName(e.target.value)
  }

  const handleDateOfBirthChange = (date) => {
    clearUserError()
    if (date != "" || date != null) setDateOfBirth(date)
  }

  const handleGenderClick = (value) => {
    clearUserError()
    setGender(value)
  }

  const handleAcceptDataProcessingClick = ({ disabled }) => {
    clearUserError()
    if (!disabled) setAcceptDataProcessing((prevstate) => !prevstate)
  }

  const handleAcceptRules = () => {
    clearUserError()
    setAcceptRules((prevstate) => !prevstate)
  }

  const handleAcceptNotifications = () => {
    clearUserError()
    setAcceptNotifications((prevstate) => !prevstate)
  }

  const handleAcceptOffers = () => {
    clearUserError()
    setAcceptOffers((prevstate) => !prevstate)
  }

  const handlePhoneChange = (e) => {
    clearUserError()
    setPhone(e.target.value)
  }

  const handlePostNumberChange = (e) => {
    clearUserError()
    setPostNumber(e.target.value)
  }

  const handlePlaceOfResidenceChange = (e) => {
    clearUserError()
    setPlaceOfResidence(e.target.value)
  }

  const handlePlaceOfResidanceDropdown = (v) => {
    clearUserError()
    setPlaceOfResidence(v)
  }

  const handleRadioSelected = (value) => {
    clearUserError()
    setTypeOfCommunication(value)
  }

  const handleEnter = (e) => {
    if (e.key === "Enter") {
      saveChanges()
    }
  }

  //////////////////////////////////////////// METHODS

  const saveChanges = async () => {
    const response = await dispatch(
      userAsyncActions.updateCustomer({
        name: name,
        surname: lastName,
        birth_date: dateOfBirth,
        gender: gender,
        permission1: acceptDataProcessing,
        permission2: acceptRules,
        permission3: acceptNotifications,
        permission4: acceptOffers,
        town_city: placeOfResidence,
        postal_code: postNumber,
        channels_code: typeOfCommunication,
        mobile: phone,
        countryCode: countryCode,
      })
    )
    //REFRESH PROFILE
    let parsedResponse = JSON.parse(response.payload.P_RESULT)

    if (parsedResponse.isSuccess === true) {
      clearUserError()
    } else {
      setErrorMsg(parsedResponse.error)
    }
  }

  const cancelChanges = () => {
    setName(userState.name)
    setLastName(userState.surname)
    setEmail(userState.email)
    setDateOfBirth(userState.birthDate)
    setGender(userState.gender ? userState.gender : "N")
    setAcceptDataProcessing(userState.permission1)
    setAcceptRules(userState.permission2)
    setAcceptNotifications(userState.permission3)
    setAcceptOffers(userState.permission4)
    setPhone(userState.mobile)
    setPostNumber(userState.postalCode)
    setPlaceOfResidence(userState.townCity)
    setTypeOfCommunication(userState.channels_code)
  }

  const clearUserError = () => {
    setErrorMsg("")
  }

  //////////////////////////////////////////// STYLE

  const styles = {
    mainContainer: {
      backgroundColor: currentColors.septenary,
      padding: "1em",
      display: "flex",
      flexDirection: "column",
      gap: "1em",
    },
    dropdown: {
      width: "100%",
      backgroundColor: currentColors.septenary,
    },
    checkboxText: {
      fontSize: "14px",
    },
    checkboxTextLink: {
      color: currentColors.primary,
      fontSize: "14px",
    },
    genderSelectorContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-start",
      paddingLeft: "0.5em",
    },
    verificationContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    checkboxRow: {
      display: "flex",
      flexDirection: "row",
    },
    checkboxContainer: {
      flex: 15,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    checkbox: {
      accentColor: currentColors.primary,
      width: "50%",
    },
    checkboxLabelContainer: { flex: 85, marginRight: "1em" },
  }

  //////////////////////////////////////////// EFFECTS

  useEffect(() => {
    setName(userState.name ?? "")
    setLastName(userState.surname ?? "")
    setEmail(userState.email ?? "")
    setDateOfBirth(userState.birthDate ?? "")
    setGender(userState.gender ?? "")
    setAcceptDataProcessing(userState.permission1 ?? "")
    setAcceptRules(userState.permission2 ?? "")
    setAcceptNotifications(userState.permission3 ?? "")
    setAcceptOffers(userState.permission4 ?? "")
    setPhone(userState.mobile ?? "")
    setCountryCode(userState.mobileCountryStart ?? "")
    setPostNumber(userState.postalCode ?? "")
    setPlaceOfResidence(userState.townCity ?? "")
    setTypeOfCommunication(userState.channels_code ?? "")
    setReferenceCode(userState.reference ?? "")
  }, [userState])

  //////////////////////////////////////////// RENDER

  return (
    <Container className="p-0" onKeyUp={(e) => handleEnter(e)}>
      <Row className="g-0 d-flex align-items-stretch">
        <Col
          style={{ backgroundColor: currentColors.septenary }}
          {...trashold4}
        >
          <div style={styles.mainContainer}>
            <BaseHeading h3 bold>
              personalData
            </BaseHeading>
            <BaseInput
              value={name}
              type="text"
              placeholder="name"
              onChange={handleNameChange}
            />
            <BaseInput
              value={lastName}
              type="text"
              placeholder="lastName"
              onChange={handleLastNameChange}
            />

            <BaseInput
              value={email}
              onChange={(e) => {
                setEmail(e.target.value)
              }}
              readOnly
              placeholder="emailAdress"
              isVerified={isMailVerified}
              verifyIconFunction={openVerifyMailModal}
            />

            <BaseDatepicker
              style={{ color: currentColors.quaternary, paddingLeft: "3px" }}
              label="dateOfBirth"
              value={dateOfBirth ? new Date(dateOfBirth) : null}
              onChange={(date) => handleDateOfBirthChange(date)}
              tip="uCanChangeBirthdayOnlyOnce"
              disabled={birthDateChanged}
            />

            <BaseDropdown2
              style={{ ...styles.dropdown }}
              value={gender}
              translate
              placeholder="gender"
              sortFunction={() => {}}
              elements={settings.dataSettings.genders.map((g) => {
                return {
                  value: g.value,
                  name: g.code,
                  isCurrent: g.value === gender,
                }
              })}
              onChange={handleGenderClick}
            />

            <DataProcessingCheckbox
              value={acceptDataProcessing}
              onChange={handleAcceptDataProcessingClick}
              disabled={req_permission1}
            />

            <ApplicationRulesCheckbox
              value={acceptRules}
              onChange={handleAcceptRules}
              disabled={req_permission2}
            />

            <NotificationsCheckbox
              value={acceptNotifications}
              onChange={handleAcceptNotifications}
              disabled={req_permission3}
            />

            <OffersPromotionsCheckbox
              value={acceptOffers}
              onChange={handleAcceptOffers}
              disabled={req_permission4}
            />
          </div>
        </Col>
        <Col
          style={{ backgroundColor: currentColors.septenary }}
          {...trashold4}
        >
          <div style={styles.mainContainer} className="h-100">
            <BaseHeading
              translate={false}
              className={`${classes.onOrAboveTrashold.show(true)}`}
              h3
              style={{ visibility: "hidden" }}
            >
              Drugi stupac naslov
            </BaseHeading>

            <div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flex: 1,
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "flex-end",
                    flex: 1,
                  }}
                >
                  <span style={{ flex: 1, marginRight: "5%" }}>
                    <BaseDropdown2
                      includeNull
                      placeholder={"countryCodeShortName"}
                      style={{ backgroundColor: "transparent" }}
                      readOnly={loginState.login.loginMethod === "MOBILE"}
                      value={countryCode}
                      translateSufix
                      elements={countriesState.countries
                        .filter((country) => {
                          if (countryCodeLocked === false) {
                            return true
                          }
                          return country.phone_code === defCountryPhoneCode
                        })
                        .map((country) => {
                          return {
                            key: country.code,
                            value: country.phone_code,
                            name: `+${country.phone_code}`,
                            optionSufix: country.translation_code,
                          }
                        })}
                      onChange={(value) => {
                        setCountryCode(value)
                      }}
                      translate={false}
                    />
                  </span>
                  <span style={{ flex: 3 }}>
                    <BaseInput
                      readOnly={loginState.login.loginMethod === "MOBILE"}
                      value={phone}
                      type="text"
                      placeholder="phoneNumber"
                      onChange={handlePhoneChange}
                      isVerified={
                        (userState.mobile ?? "") === "" ||
                        samePhoneAsDB === false
                          ? null
                          : isPhoneVerified
                      }
                      verifyIconFunction={openVerifyMobileModal}
                      verificationIconTitle="phoneNotVerifiedMessage"
                    />
                  </span>
                </div>
              </div>
            </div>
            <div>
              <BaseInput
                value={postNumber}
                type="text"
                placeholder="postNumber"
                onChange={handlePostNumberChange}
              />
            </div>
            {systemState.settings.fk_town_city === false && (
              <BaseInput
                value={placeOfResidence}
                type="text"
                placeholder="placeOfResidence"
                onChange={handlePlaceOfResidenceChange}
              />
            )}
            {systemState.settings.fk_town_city === true && (
              <BaseDropdown2
                placeholder="chooseCity"
                style={{ backgroundColor: "transparent" }}
                elements={citiesState.cities.map((city) => {
                  return {
                    key: city.code,
                    value: city.code,
                    name: `${city.name}`,
                  }
                })}
                onChange={handlePlaceOfResidanceDropdown}
                value={placeOfResidence}
                translate
                includeNull
              />
            )}
            {systemState.settings.hide_channels_code === false && (
              <>
                <BaseHeading h4 bold>
                  chosenTypeOfCommunication
                </BaseHeading>
                <BaseRadioButton
                  name="contactRadio"
                  onChange={handleRadioSelected}
                  value={typeOfCommunication}
                  elements={[
                    { value: "EMAIL", name: "emailShort" },
                    { value: "SMS", name: "sms" },
                    { value: null, name: "noneOfTheAbove" },
                  ]}
                />{" "}
              </>
            )}

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <BaseInput
                value={referenceCode}
                type="text"
                placeholder="Kôd preporuke"
                translate={false}
              />
              <div
                style={{
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: currentColors.primary,
                  gap: 3,
                  minWidth: 90,
                  paddingTop: 10,
                }}
              >
                <CopyToClipboard
                  text={referenceCode}
                  onCopy={() => setIsCopied(true)}
                >
                  <div>
                    <BaseImage
                      buildSrcFromConnection={false}
                      style={{ width: 20 }}
                      src={isCopied ? CheckmarkSVG : CopySVG}
                    />
                    <BaseParagraph
                      style={{ color: currentColors.primary }}
                      translate={false}
                    >
                      {isCopied ? "Kopirano" : "Kopiraj"}
                    </BaseParagraph>
                  </div>
                </CopyToClipboard>
              </div>
            </div>

            <BaseButton
              error={errorMsg}
              errorContainerAlwaysVissible={false}
              onClick={() => {
                saveChanges()
              }}
              hasMarginTop={false}
            >
              save
            </BaseButton>
            <BaseButton
              secondaryButton
              onClick={() => {
                cancelChanges()
              }}
              hasMarginTop={false}
            >
              cancel
            </BaseButton>
          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default WithVerifyMobileModal(
  WithVerifyMailModal(PersonalDataComponent2)
)
